import {
  ref, computed, onMounted, watch,
} from '@vue/composition-api'

import format from 'date-fns/format'

import useRequest from '@/compositions/useRequest'
import useForm from '@/compositions/useForm'

import {
  min, medium, parse, backendFormat, dayMonth,
} from '@/utils/formatDate'
import { required } from '@/utils/validations'
import StatisticsByDay from '../StatisticsByDay/StatisticsByDay'


export default ({
  props: {
    orderId: Number,
    orderDates: Array,
    orderOwner: Number,
    orderDriver: Object,
    groupedMachineHours: Object,
  },
  components: { StatisticsByDay },
  setup(props, context) {
    const { $store } = context.root

    const machineHours = ref({})
    const reservedMachineHours = ref(0)
    const machineHoursTimes = ref({})
    const popupItems = ref({})
    const workComments = ref([])
    const popup = ref(false)
    const addMachineHoursPopup = ref(false)
    const calendar = ref(null)
    const currentMonth = ref('')
    const selectedDate = ref(null)
    const selectedHours = ref(null)
    const exDaysCount = ref(0)
    const allMachineHours = ref(0)
    const downtimes = ref(0)
    const shifts = ref(0)
    const value = ref(backendFormat(new Date()))
    const myCompanyId = computed(() => $store.state.auth.company?.id)
    const headers = [
      { text: 'Дата', value: 'day', sortable: true },
      { text: 'Комментарий', value: 'text', sortable: false },
    ]
    const events = []

    const machineHoursRequest = useRequest({
      context,
      request: () => $store.dispatch('orders/getMachineHours', { id: props.orderId }),
    })

    const workCommentsRequest = useRequest({
      context,
      request: () => $store.dispatch('orders/getWorkComments', { id: props.orderId }),
    })

    const postCommentRequest = useRequest({
      context,
      request: data => $store.dispatch('orders/postWorkComment', data),
    })

    const calendarStatisticsRequest = useRequest({
      context,
      request: id => $store.dispatch('calendar/getStatistics', id),
    })

    const fetchHours = async () => {
      const payload = await machineHoursRequest.makeRequest()
      machineHours.value = payload.machineHours
      machineHoursTimes.value = payload.machineHoursTimes
      popupItems.value = payload.groupedDrivers
      reservedMachineHours.value = payload.reservedMachineHours
    }

    const fetchComments = async () => {
      const payload = await workCommentsRequest.makeRequest()
      workComments.value = payload.workComments
    }

    const getHours = val => (val / 3600).toFixed(1)

    const getDateString = val => backendFormat(parse(val))

    const getTimeString = (val) => {
      const time = new Date(Date.parse(val))
      const hours = time.getHours() < 10 ? `0${time.getHours()}` : `${time.getHours()}`
      const minutes = time.getMinutes() < 10 ? `0${time.getMinutes()}` : `${time.getMinutes()}`
      return `${hours}:${minutes}`
    }

    const getDateTimeString = (val) => {
      const time = new Date(Date.parse(val))
      const hours = time.getHours() < 10 ? `0${time.getHours()}` : `${time.getHours()}`
      const minutes = time.getMinutes() < 10 ? `0${time.getMinutes()}` : `${time.getMinutes()}`
      return `${dayMonth(time)} ${hours}:${minutes}`
    }

    const daysInfo = computed(() => Object.keys(machineHours.value).reduce((obj, key) => {
      const date = getDateString(key)
      const driver = props.orderDriver
      if (!date) return obj
      obj[date] = {
        start: getTimeString(machineHoursTimes.value[key][0]),
        end: getTimeString(machineHoursTimes.value[key][1]),
        driver: driver ? `${driver.name} ${driver.phone}` : 'нет данных',
        hoursWorked: props.groupedMachineHours[key] ? props.groupedMachineHours[key].map(el => el.machineHours) : '',
        key,
      }
      return obj
    }, {}))

    const getStatistics = async () => {
      const { allHours, downtime, shiftCount } = await calendarStatisticsRequest.makeRequest(props.orderId)
      // кол-во часов
      allMachineHours.value = allHours
      // кол-во смен
      shifts.value = shiftCount
      // простои
      downtimes.value = downtime
    }

    const fetchAll = async () => {
      fetchComments()
      await fetchHours()
      getStatistics()
    }

    const comments = computed(() => workComments.value)
    const dayComments = date => workComments.value.filter(comment => comment.day === date)
    const {
      getData, validate, reset, formData, $errors,
    } = useForm({
      fields: {
        text: { default: '', validations: { required } },
      },
    })

    const submit = async () => {
      if (!validate()) return

      await postCommentRequest
        .makeRequest({
          ...getData(),
          orderId: props.orderId,
          day: selectedDate.value,
        })

      popup.value = false
      reset()
      fetchAll()
    }

    const handleClick = (e) => {
      const { date } = e
      popup.value = true
      selectedDate.value = date

      selectedHours.value = machineHours.value[date.replace(/\D/g, '')] || 0
    }

    const init = () => {
      fetchAll()
      calendar.value.checkChange()
    }

    const update = () => {
      init()
      addMachineHoursPopup.value = false
    }

    onMounted(() => {
      init()
    })

    watch(() => calendar.value, (val) => {
      if (!val) return
      init()
    })
    watch(() => calendar.value?.title, () => {
      currentMonth.value = `${calendar.value?.title} г.`
      getStatistics()
    })


    return {
      events,
      comments,
      daysInfo,
      popupItems,
      getHours,
      getDateTimeString,
      handleClick,
      popup,
      addMachineHoursPopup,
      submit,
      formData,
      $errors,
      selectedDate,
      calendar,
      value,
      headers,
      currentMonth,
      exDaysCount,
      allMachineHours,
      downtimes,
      shifts,
      dayComments,
      selectedHours,
      min,
      medium,
      update,
      myCompanyId,

      hoursLoading: machineHoursRequest.loading,
      commentsLoading: workComments.loading,
      postLoading: postCommentRequest.loading,

      end: format(new Date(), 'yyyy-MM-dd'),
    }
  },
})
